module.exports = __webpack_public_path__ + "static/media/panel2.9993a00c.jpg";